import React from "react";

const Collapse = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M25.054 9.691 32.744 2 34 3.257l-7.691 7.69 4.397 4.397h-10.05V5.294l4.398 4.397ZM10.946 26.308 3.256 34 2 32.743l7.69-7.69-4.397-4.397h10.05v10.05l-4.397-4.398ZM9.692 10.946 2 3.256l1.257-1.255 7.69 7.69 4.398-4.397v10.05H5.295l4.397-4.398ZM26.308 25.053 34 32.743l-1.257 1.256-7.69-7.69-4.398 4.397v-10.05h10.05l-4.397 4.397Z"
        />
    </svg>
);

export default Collapse;